/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Corrections_LabelInputs */



/**
* | output |
* | --- |
* | "Corrections" |
*
* @param {Spellcheck_Corrections_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_corrections_label = /** @type {((inputs?: Spellcheck_Corrections_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Corrections_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corrections")
	if (locale === "de") return /** @type {LocalizedString} */ ("Korrekturen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исправления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correcciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更正")
	if (locale === "ja") return /** @type {LocalizedString} */ ("訂正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सुधार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Correções")
	return /** @type {LocalizedString} */ ("Corrections")
});